<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import FileBox from '../common/FileBox.vue'
import CheckMoreText from '../common/CheckMoreText.vue'

import { getPageThemeColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp26',
  components: { ModuleTitle, FileBox, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getPageThemeColor }
}
</script>

<template>
  <div class="modules-id-26">
    <module-title :title="moduleOption.title" margin-bottom="25" />
    <div class="comp-transverse-2 modules-id-26-content pointer">
      <div v-for="v in moduleOption.list.slice(0, 5)" :key="`modules-26-${v.id}`">
        <file-box :headline="v.headline" :filename="v.typename" :createtime="v.createtime" />
      </div>
      <check-more-text class="check-more-26" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-26-content {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  gap: 24px;
  .check-more-26 {
    margin: 35px 0 0 140px;
  }
}
</style>
